<ng-container *ngIf="isLilateAvailable()===true">
    <div class="text-xl font-semibold leading-tight">
        <div class="flex text-xl text-center mt-5" translate [translateParams]="{language:lilate.language.label}">
            lilate-exam.certif.name.1
        </div>
        <div class="flex w-full justify-center mt-5">
            <img class="w-6 h-6 ml-2" src="{{lilate.language.flag}}" alt="language-flag">
        </div>
    </div>
    <div class="font-medium my-5 text-center text-secondary" translate
        [translateParams]="{ date: lilate.start | amLocale: 'fr' | amDateFormat:'DD MMMM YYYY' }">
        lilate-exam.session-content.done-date <span *ngIf="lilate.external_organisation_name" translate
            [translateParams]="{ of: lilate.external_organisation_name }">lilate-exam.orga.name.via</span>
    </div>
    <div class="text-center text-red-500 mb-5"
        *ngIf="lilate && ((lilate.student.user.photo_profile && lilate.student.user.photo_profile.status !== 'validated') || (lilate.identity_issue))"
        translate>
        lilate.dashboard.identityNotValidated
    </div>
    <div class="text-center" *ngIf="!lilate.level_global" translate>
        lilate-exam.session-content.isPendingAssessment
    </div>
    <hr class="w-full border-t my-6">

    <ng-container>
        <div class="grid grid-cols-1 gap-y-4 mt-6">
            <div class="flex items-center">
                <div class="font-medium text-secondary" translate>lilate.dashboard.nextStepsTitle</div>
            </div>
            <div class="flex items-center">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:arrow-circle-right'"></mat-icon>
                <div class="ml-2" translate>lilate.dashboard.reportingProgress</div>
            </div>
            <div class="flex items-center">
                <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:arrow-circle-right'"></mat-icon>
                <div class="ml-2" translate>lilate.dashboard.resultEmailInfo</div>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="isLilateAvailable()===false">
    <div class="font-bold text-2xl" translate>lilate-exam.session-content.isPendingAssessment</div>
</ng-container>